import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Form, Field } from 'formik';
import Yup from 'yup';
import MainTitle from 'base/components/MainTitle/index';
import SubmitButton from 'base/components/forms/SubmitButton';
import FormikInputField from 'base/components/forms/formik/FormikInputField';
import { updateRole } from 'auth/store/roles/actions';
import { getActiveRole } from 'auth/store/roles/selectors';
import { closeModal } from 'modal/store/actions';


const EditRoleForm = ({errors, isSubmitting}) => ( // eslint-disable-line
  <Form>
    <Field
      type="text"
      name="name"
      placeholder="Name"
      component={FormikInputField}
      autoFocus
    />
    <SubmitButton type="submit" disabled={isSubmitting}>
        Update Role
    </SubmitButton>
  </Form>
);


const UpdateRoleModal = ({
  name, role, updateRole, closeModal,
}) => (
  <>
    <MainTitle withRoleBelow>Edit Role</MainTitle>

    <Formik
      initialValues={{
        name: role.name,
      }}
      validationSchema={
            Yup.object().shape({
              name: Yup.string()
                .required('Name is required.'),
            })
          }
      render={EditRoleForm}
      onSubmit={(values) => {
        const updatedRole = {
          ...role,
          name: values.name,
        };
        updateRole(updatedRole);
        closeModal(name);
      }}
    />
  </>
);
UpdateRoleModal.propTypes = {
  name: PropTypes.string.isRequired,
  role: PropTypes.object.isRequired, // eslint-disable-line
  updateRole: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  role: getActiveRole(state),
});


const mapDispatchToProps = {
  updateRole,
  closeModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UpdateRoleModal);
